import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './app/app';
import { Provider } from 'react-redux';
import store from './store';
import { AppThemeProvider, Auth0RedirectHandler, GlobalNotification } from '@senderra/shared';
import { AuthProvider } from '@senderra/shared/features/auth';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <AuthProvider>
                    <AppThemeProvider>
                        <Auth0RedirectHandler />
                        <App />
                        <GlobalNotification />
                    </AppThemeProvider>
                </AuthProvider>
            </BrowserRouter>
        </Provider>
    </StrictMode>
);
